import React from 'react';
import { Box, Typography } from '@mui/material';
import i18n from '../../i18n';
import './form-field-cell.scss';

/** 标签文案：i18n 键或直接展示（二选一） */
export type FormFieldCellLabelProps =
    | { labelKey: string; label?: never }
    | { label: React.ReactNode; labelKey?: never };

export type FormFieldCellProps = FormFieldCellLabelProps & {
    /** 多行标签样式（如换行说明） */
    multilineLabel?: boolean;
    /** 控件区为下拉时增加右对齐等修饰 */
    select?: boolean;
    /** 附加在 `.menu-library-add-dish__cell` 上，如左右分布数值格 */
    cellClassName?: string;
    /**
     * 单元格外框描边语义色：`100` 为默认（与设计系统菜单库表单格一致），`300` 为强调描边。
     */
    strokePrimary?: '100' | '300';
    children: React.ReactNode;
};

/**
 * 表单「左标签 + 右控件」单元格，与菜单库新增菜品弹窗视觉一致；
 * 默认外框 `--stroke-primary-100`，可通过 `strokePrimary="300"` 切换强调描边。
 */
export function FormFieldCell(props: FormFieldCellProps) {
    const { multilineLabel, select, cellClassName, strokePrimary = '100', children } = props;
    const labelContent = 'labelKey' in props && props.labelKey != null ? i18n.t(props.labelKey) : props.label;

    /** 外框描边：默认 100；300 时叠加修饰类 */
    const strokeClass =
        strokePrimary === '300' ? 'menu-library-add-dish__cell--stroke-primary-300' : '';

    return (
        <Box
            className={['menu-library-add-dish__cell', strokeClass, cellClassName ?? ''].filter(Boolean).join(' ')}
        >
            <Typography
                component="span"
                className={[
                    'menu-library-add-dish__cell-label',
                    multilineLabel ? 'menu-library-add-dish__cell-label--multiline' : '',
                ]
                    .filter(Boolean)
                    .join(' ')}
            >
                {labelContent}
            </Typography>
            <Box
                className={[
                    'menu-library-add-dish__cell-control',
                    select ? 'menu-library-add-dish__cell-control--select' : '',
                ]
                    .filter(Boolean)
                    .join(' ')}
            >
                {children}
            </Box>
        </Box>
    );
}

export default FormFieldCell;
